import { useRef, useState } from 'react'

import { BillingPriceInterval } from '@tribeplatform/gql-client/types'
import { useBillingProducts } from '@tribeplatform/react-sdk/hooks'
import { Modal } from '@tribeplatform/react-ui-kit/Modal'

import { SegmentProvider } from '../../../../providers/SegmentProvider.js'
import { PlanCardsSection } from '../PlanCards/PlanCardsSection.js'

import { TrialMessagePanel } from './TrialMessagePanel.js'
import { useEnforceModalPresence } from './useEnforceModalPresence.js'

export const TrialExpiredModal = () => {
  const overlayRef = useRef<HTMLDivElement>(null)
  const [billingInterval, setBillingInterval] = useState(
    BillingPriceInterval.Year,
  )
  const { data: products, isInitialLoading: productsLoading } =
    useBillingProducts()
  const plans = products?.plans ?? []
  useEnforceModalPresence({ modalRef: overlayRef })

  return (
    <SegmentProvider>
      <Modal
        open
        onClose={() => null}
        size="full"
        showCloseBtn={false}
        closeOnBackdropClick={false}
        scrollable={false}
      >
        <div
          ref={overlayRef}
          className="@container/trial-expired max-w-full px-6 py-8 sm:px-8 lg:px-12 lg:py-10"
        >
          <div className="grid gap-8 @6xl/trial-expired:grid-cols-[max-content_minmax(0,1fr)] @6xl/trial-expired:items-start @6xl/trial-expired:gap-10">
            <div className="@6xl/trial-expired:pt-4">
              <TrialMessagePanel />
            </div>

            <div className="min-w-0">
              <PlanCardsSection
                isLoading={productsLoading}
                plans={plans}
                selectedInterval={billingInterval}
                onIntervalChange={setBillingInterval}
              />
            </div>
          </div>
        </div>
      </Modal>
    </SegmentProvider>
  )
}
